
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developers/api/docs",
      function () {
        return require("private-next-pages/developers/api/docs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developers/api/docs"])
      });
    }
  